import React, { ReactElement, Fragment } from "react";
import classnames from "classnames";

import { Icon } from "@sportal/cdk";

import "./MobileModalListBody.scss";

const ICONS = {
  rename: "fa-regular fa-pencil",
  edit_info: "fa-regular fa-pencil",
  merge: "fa-regular fa-link",
  assign: "fa-regular fa-plus",
  remove: "fa-regular fa-trash",
  revoke_access: "fa-regular fa-ban",
  unmerge: "fa-regular fa-unlink",
  move: "fa-regular fa-chevron-double-right",
};

interface MobileModalListBodyProps {
  items: ReactElement[];
}

export const MobileModalListBody = ({ items }: MobileModalListBodyProps) => {
  return (
    <ul className="mobile-modal-list-body">
      {items.map((item, index) => (
        <Fragment key={index}>{item} </Fragment>
      ))}
    </ul>
  );
};

export interface MobileModalListItemProps {
  content: ReactElement;
  action: () => void;
  disabled?: boolean;
  id: string;
  icon?: string;
  isSelected?: boolean;
}

export const MobileModalListItem = ({
  disabled,
  id,
  action,
  icon,
  content,
  isSelected = false,
}: MobileModalListItemProps) => {
  const iconClass = icon || ICONS[id];

  return (
    <li
      className={classnames(
        "mobile-modal-list-body__item",
        disabled && "mobile-modal-list-body__item--disabled"
      )}
      key={id}
    >
      <button
        className={classnames(
          "mobile-modal-list-body__item-button",
          isSelected && "mobile-modal-list-body__item-button--sorted"
        )}
        type="button"
        onClick={action}
        disabled={disabled}
      >
        <span aria-hidden="true" className="icon-wrapper">
          {iconClass && <Icon icon={iconClass} />}
        </span>
        {content}
      </button>
    </li>
  );
};
